var _ellipse, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6423473Ee7C6Dd7E31245531EditorialDesignIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 76,
    viewBox: "0 0 95 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.093,
    cy: 13.6429,
    rx: 13.4987,
    ry: 13.6429,
    fill: "#FF7020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5496 63.6138V13.7139H67.5943V68.1635H50.0852M50.0852 68.1635H22.5496V63.6187C22.5496 57.6679 17.7256 52.8439 11.7748 52.8439V52.8439C5.82404 52.8439 1 57.6679 1 63.6187V63.9824C1 70.1341 5.9869 75.121 12.1386 75.121H50.0852V68.1635Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.1097,
    y: 19.5469,
    width: 33.8628,
    height: 21.0534,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5496 18.7054V16.7753C22.5496 10.8245 17.7256 6.00049 11.7748 6.00049V6.00049C5.82404 6.00049 1 10.8245 1 16.7753V64.3701",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6423473Ee7C6Dd7E31245531EditorialDesignIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6423473ee7c6dd7e31245531_editorial-design-icon-darkstudio-x-webflow-template.f758e54f4646202499a7d5d9082ae35c.svg";
export { ForwardRef as ReactComponent };